export default __webpack_public_path__ + "images/daac99e7b32baa031ae665212321a285-fashion.jpg";